import { render, staticRenderFns } from "./CorporateAnnouncementStockDetails.vue?vue&type=template&id=6884a336&scoped=true"
import script from "./CorporateAnnouncementStockDetails.vue?vue&type=script&lang=js"
export * from "./CorporateAnnouncementStockDetails.vue?vue&type=script&lang=js"
import style0 from "./CorporateAnnouncementStockDetails.vue?vue&type=style&index=0&id=6884a336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6884a336",
  null
  
)

export default component.exports